import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectMappedSnowflakeStatus, selectIsSnowflakeConnected } from 'app/store/healthcheck';
import { SnowflakeDisconnectedOverlay } from './SnowflakeDisconnectedOverlay.jsx';

const mapStateToProps = createStructuredSelector({
    isSnowflakeConnected: selectIsSnowflakeConnected,
    mappedSnowflakeStatus: selectMappedSnowflakeStatus
});

export const SnowflakeDisconnectedOverlayContainer = connect(mapStateToProps)(
    SnowflakeDisconnectedOverlay
);
